<div class="welcome-wrapper">
  @if (imgUrl.length !== 0) {
  <img alt="Logo" [src]="imgUrl" />
  }
</div>
